import * as jwtDecode from 'jwt-decode';
// import createActivityDetector from 'activity-detector';
import { checkLocation } from './browserHistoryUtils';
import { isTokenExpired } from '../components/Auth/utils';
// import { homeRoute } from '../config/navigation/routes';
import { homeRoute, loginFailureRoute } from '../config/navigation/routes';
// import { homeRoute } from '../config/navigation/routes';
// import lock from '../components/Auth/lock';
import { logoutServices } from '../graphql/serviceAuthentication'
import logService from '../graphql/logging';

// const activityDetector = createActivityDetector();

export function getAuthToken() {
  const name = `idToken=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export function checkAuth(token) {
  const onRegistration = checkLocation();
  if (!onRegistration) {
    const { exp } = jwtDecode(token);
    if (!token || isTokenExpired(exp)) {
      logout();
    }
  }
}

export function checkIfAuthIsValid(auth) {
  if (!auth.jwtToken || !auth.expiration || !auth.role || !auth.id) {
    return false;
  }
  if (auth.expiration <= 1) {
    return false;
  }
  return true;
}

export function logout() {
  const jwt = getAuthToken();
  const decoded = jwtDecode(jwt);
  const email = decoded.email;
  logoutServices(email);
  // setTimeout(() => this.setState(''), 300);
  document.cookie = 'idToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

  // see if below removes affect the logout process
  // localStorage.removeItem('supplierSearchParams');
  // localStorage.removeItem('procurementHistoryURL');
  // localStorage.removeItem('toolingSearchURL');
  // sessionStorage.removeItem("udHistory");
  // localStorage.removeItem('auth0.ssodata');

  // localStorage.removeItem('idToken');
  // lock.logout({ returnTo: process.env.REACT_APP_CALLBACK_BASE_URL });
  // activityDetector.stop();  
  window.location = homeRoute;
}

export async function logoutAfterLoginFailure(res) {
  const jwt = getAuthToken()
  const decoded = jwtDecode(jwt);
  const email = decoded.email
  const postLogsBody = {
    level: 'severe',
    message: `${email} failed to login to services. ${JSON.stringify(res)}`,
    className: 'pn-nffs-solicitation-search/src/utils/authUtils.js',
    methodName: 'logoutAfterLoginFailure',
  };

  document.cookie = 'idToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  localStorage.removeItem('auth0.ssodata');

  try {
    await logService(postLogsBody);
  } catch (error) {
    console.error({ msg: 'Unable to send error log to DB2!', postLogsBody }, error);
  }

  window.location = loginFailureRoute;
}


export default { checkAuth };


// WEBPACK FOOTER //
// ./src/utils/authUtils.js